<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="officeForm.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
                disabled
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Country"
            rules="required"
          >
            <b-form-group
              label="Country"
              label-for="country"
            >
              <b-form-input
                id="country"
                v-model="officeForm.country"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Country"
                disabled
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Currency"
            label-for="Currency"
          >
            <v-select
              v-model="officeForm.currency"
              :options="currencyOptions"
              placeholder="Select Currency"
              label="text"
              :searchable="true"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6" />

        <b-col md="4">
          <b-form-group
            label="overseas audit cost per day for auditor"
            label-for="overseas audit cost per day for auditor"
          >
            <b-form-input
              id="overseas_audit_cost_per_day_for_auditor"
              v-model="officeForm.overseas_audit_cost_per_day_for_auditor"
              trim
              placeholder="overseas audit cost per day for auditor"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="overseas audit cost per day for lead auditor"
            label-for="overseas audit cost per day for lead auditor"
          >
            <b-form-input
              id="overseas_audit_cost_per_day_for_lead_auditor"
              v-model="officeForm.overseas_audit_cost_per_day_for_lead_auditor"
              trim
              placeholder="overseas audit cost per day for lead auditor"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="overseas audit cost per day for observer"
            label-for="overseas audit cost per day for observer"
          >
            <b-form-input
              id="overseas_audit_cost_per_day_for_observer"
              v-model="officeForm.overseas_audit_cost_per_day_for_observer"
              trim
              placeholder="overseas audit cost per day for observer"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="onsite audit cost per day for auditor"
            label-for="onsite audit cost per day for auditor"
          >
            <b-form-input
              id="onsite_audit_cost_per_day_for_auditor"
              v-model="officeForm.onsite_audit_cost_per_day_for_auditor"
              trim
              placeholder="onsite audit cost per day for auditor"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="onsite audit cost per day for lead auditor"
            label-for="onsite audit cost per day for lead auditor"
          >
            <b-form-input
              id="audit_cost_per_day_for_lead_auditor"
              v-model="officeForm.onsite_audit_cost_per_day_for_lead_auditor"
              trim
              placeholder="onsite audit cost per day for lead auditor"
            />
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="onsite audit cost per day for observer"
            label-for="onsite audit cost per day for observer"
          >
            <b-form-input
              id="onsite_audit_cost_per_day_for_observer"
              v-model="officeForm.onsite_audit_cost_per_day_for_observer"
              trim
              placeholder="onsite audit cost per day for observer"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="over time rate"
            label-for="over time rate"
          >
            <b-form-input
              id="over_time_rate"
              v-model="officeForm.over_time_rate"
              trim
              placeholder="over time rate"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Leaves Balance"
            rules="required"
          >
            <b-form-group
              label="Leaves Balance"
              label-for="Leaves Balance"
            >
              <table class="table table-sm table-bordered mb-0 w-50">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in officeForm.leaves_balance"
                    :key="item.id"
                  >
                    <td>{{ item.type }}</td>
                    <td>
                      <b-form-input
                        id="item.type"
                        v-model="item.balance"
                        type="number"
                      /></td>
                  </tr>
                </tbody>
              </table>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

        </b-col>
        <b-col md="6">
          <b-form-group label="Yearly Holidays">

            <!-- LIST -->
            <div
              v-for="(holiday, index) in officeForm.yearly_holidays"
              :key="index"
              class="d-flex align-items-center mb-1 gap-1"
            >
              <!-- DATE -->
              <b-form-input
                v-model="holiday.date"
                type="date"
                class="mr-1"
              />

              <!-- NAME -->
              <b-form-input
                v-model="holiday.name"
                placeholder="Holiday name"
                class="mr-1"
              />

              <!-- DELETE -->
              <b-button
                variant="danger"
                size="sm"
                @click="removeHoliday(index)"
              >
                ✕
              </b-button>
            </div>

            <!-- ADD NEW -->
            <b-button
              variant="outline-primary"
              size="sm"
              class="mt-1"
              @click="addHoliday"
            >
              + Add Holiday
            </b-button>

          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Weekly Holiday">
            <v-select
              v-model="officeForm.weekly_holiday"
              :options="optionsWeeklyHoliday"
              :reduce="option => option.value"
              multiple
            />
          </b-form-group>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addOffice()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addOffice()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect, // Register vue-select component
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      allSelected: [],
      users: [],
      loader: false,
      validationErrors: {},
      errors: {},
      currencyOptions: [],
      optionsWeeklyHoliday: [
        { value: 'Monday', label: 'Monday' },
        { value: 'Tuesday', label: 'Tuesday' },
        { value: 'Wednesday', label: 'Wednesday' },
        { value: 'Thursday', label: 'Thursday' },
        { value: 'Friday', label: 'Friday' },
        { value: 'Saturday', label: 'Saturday' },
        { value: 'Sunday', label: 'Sunday' },
      ],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const officeForm = ref({
    })
    return {
      getValidationState,
      officeForm,
    }
  },
  mounted() {
    this.showOffice()
    axios
      .get('https://gulftic-system.fci.group/api/currency/available')
      .then(res => {
        this.currencyOptions = decryptData(res.data.payload).data?.currencies?.map(currency => ({
          value: currency,
          text: currency,
        }))
      })
      .catch(error => {
        // console.error('Error fetching currencies:', error)
        if (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error fetching currencies',
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        }
      })
  },
  methods: {
    showOffice() {
      if (this.$route.params.id) {
        axios.get(`office/${this.$route.params.id}`).then(res => {
          this.officeForm = decryptData(res.data.payload).data.office

          if (!Array.isArray(this.officeForm.yearly_holidays)) {
            this.officeForm.yearly_holidays = []
          }
        })
      } else {
        return false
      }
      return true
    },
    addHoliday() {
      this.officeForm.yearly_holidays.push({
        date: '',
        name: '',
      })
    },

    removeHoliday(index) {
      this.officeForm.yearly_holidays.splice(index, 1)
    },

    addOffice() {
      if (this.$route.params.id) {
        this.loader = true

        const payload = {
          _method: 'PUT',
          // iban: this.officeForm.iban,
          // swift_code: this.officeForm.swift_code,
          // bank_account_number: this.officeForm.bank_account_number,
          // bank_account_name: this.officeForm.bank_account_name,
          // check_name: this.officeForm.check_name,
          leaves_balance: this.officeForm.leaves_balance,
          yearly_holidays: this.officeForm.yearly_holidays,
          weekly_holiday: this.officeForm.weekly_holiday,
          overseas_audit_cost_per_day_for_auditor: this.officeForm.overseas_audit_cost_per_day_for_auditor,
          overseas_audit_cost_per_day_for_lead_auditor: this.officeForm.overseas_audit_cost_per_day_for_lead_auditor,
          overseas_audit_cost_per_day_for_observer: this.officeForm.overseas_audit_cost_per_day_for_observer,
          onsite_audit_cost_per_day_for_auditor: this.officeForm.onsite_audit_cost_per_day_for_auditor,
          onsite_audit_cost_per_day_for_lead_auditor: this.officeForm.onsite_audit_cost_per_day_for_lead_auditor,
          onsite_audit_cost_per_day_for_observer: this.officeForm.onsite_audit_cost_per_day_for_observer,
          over_time_rate: this.officeForm.over_time_rate,
        }

        axios
          .post(`office/${this.$route.params.id}`, payload)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'office' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
      //  else {
      //   this.loader = true
      //   const formData = new FormData()

      //   // Use Object.entries() to iterate over the object's own properties
      //   Object.entries(this.officeForm).forEach(([key, value]) => {
      //     if (key === 'currency' && value && typeof value === 'object') {
      //       formData.append(key, value.value) // Adjust this depending on the structure of your currency object
      //     } else {
      //       formData.append(key, value)
      //     }
      //   })

      //   axios
      //     .post('office', formData)
      //     .then(res => {
      //       if (res.status === 200 || res.status === 201) {
      //         this.$router.push({ name: 'office' })
      //         this.$toasted.show('Created Successfully', {
      //           position: 'top-center',
      //           duration: 3000,
      //         })
      //       }
      //     })
      //     .catch(error => {
      //       if (error.response.status) {
      //         this.$toast({
      //           component: ToastificationContent,
      //           props: {
      //             title: `${error.response.data.message}`,
      //             icon: 'BellIcon',
      //             variant: 'error',
      //           },
      //         })
      //       }
      //     })
      //     .finally(() => {
      //       this.loader = false
      //     })
      // }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
